"use client";

import { useLocale } from "@cloudspire/shared/contexts/Locale";
import { useCallback } from "react";
import { IntlProvider } from "react-intl";

/**
 * @typedef {object} Props
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
export function IntlProviderWrapper({ children }) {
  const { locale, messages } = useLocale();

  const handleError = useCallback(
    /** @param {any} error */
    (error) => {
      if (error.code === "MISSING_TRANSLATION") {
        return;
      } else {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
    [],
  );

  return (
    <IntlProvider locale={locale} messages={messages} onError={handleError}>
      {children}
    </IntlProvider>
  );
}
